import { Injectable } from '@angular/core'
import { MbCheckoutBillingAddressesAdapter } from './mb-checkout-billing-addresses.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbCheckoutBillingAddressesConnector {

  constructor (protected adapter: MbCheckoutBillingAddressesAdapter) {
  }

  get () {
    return this.adapter.load()
  }
}
